
import {useNavigate, useParams} from 'react-router-dom';
import {articles} from '../articleData/articleData';
import styled from "styled-components";


function DetailBlog() {

    const { slug } = useParams();
    const navigate = useNavigate();

    return (
        <div className="layout">
            <Button onClick={() => navigate(-1)}>
                Zpět
            </Button>
            <h1>
                {articles[slug].title}
            </h1>
            <BlogDetail>
                {articles[slug].text}
            </BlogDetail>
        </div>
    );
}

const Button = styled.button `
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  padding: 10px 20px 10px 20px;
  background-color: white;
`
const BlogDetail = styled.div `
  margin-bottom:150px;  
`
export default DetailBlog;
